import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { waLink, WHATSAPP_DISPLAY } from "../../data/content";

const HERO_BG = "https://images.unsplash.com/photo-1706922122654-e209628fdd48";

const lineParent = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.3 } },
};
const lineChild = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 1, ease: [0.22, 1, 0.36, 1] } },
};

const Line = ({ children, className }) => (
  <span className="block overflow-hidden">
    <motion.span variants={lineChild} className={`block ${className}`}>{children}</motion.span>
  </span>
);

export const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const bgY = useTransform(scrollYProgress, [0, 1], ["0%", "30%"]);
  const fade = useTransform(scrollYProgress, [0, 0.8], [1, 0]);

  return (
    <section ref={ref} data-testid="hero-section" className="relative h-[100svh] min-h-[640px] overflow-hidden">
      <motion.div style={{ y: bgY }} className="absolute inset-0 -z-10">
        <img src={HERO_BG} alt="Velas encendidas para una consulta de tarot y clarividencia en Asturias"
          className="w-full h-[120%] object-cover" />
        <div className="absolute inset-0 bg-[#05030A]/70" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#05030A]/40 via-transparent to-[#05030A]" />
      </motion.div>

      <motion.div style={{ opacity: fade }}
        className="relative h-full max-w-6xl mx-auto px-5 sm:px-8 flex flex-col justify-center">
        <motion.div variants={lineParent} initial="hidden" animate="show">
          <motion.span variants={lineChild} className="inline-block overflow-hidden">
            <span className="block text-xs uppercase tracking-[0.35em] text-[#C5A059] mb-6">
              Tarotista fiable · Asturias · +26 años
            </span>
          </motion.span>

          <h1 aria-label="Clarividencia Luz Sagrada"
            className="font-serif text-[#F3EFE7] tracking-tighter leading-[0.95] text-5xl sm:text-7xl md:text-8xl">
            <Line>Clarividencia</Line>
            <Line className="italic text-[#C5A059]">Luz Sagrada</Line>
          </h1>

          <motion.p variants={lineChild}
            className="mt-8 max-w-xl text-base md:text-lg text-white/75 leading-relaxed">
            Tarot, retornos de pareja y limpiezas espirituales con más de 26 años de
            experiencia. Vidente sin gabinete ni intermediarios. Te ayudo yo misma, sin rodeos.
          </motion.p>

          <motion.div variants={lineChild} className="mt-10 flex flex-wrap items-center gap-4">
            <a data-testid="hero-whatsapp-cta" href={waLink("Hola Luz Sagrada, quiero pedir una consulta.")}
              target="_blank" rel="noopener noreferrer"
              className="rounded-full bg-[#C5A059] text-[#05030A] px-8 py-4 font-medium hover:bg-[#D4AF37] transition-colors duration-300">
              Consulta por WhatsApp
            </a>
            <a data-testid="hero-phone" href={waLink()} target="_blank" rel="noopener noreferrer"
              className="text-white/80 hover:text-[#C5A059] transition-colors duration-300">
              {WHATSAPP_DISPLAY}
            </a>
          </motion.div>
        </motion.div>
      </motion.div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[#C5A059]/70 animate-bounce">
        <ArrowDown size={22} />
      </div>
    </section>
  );
};
